
export default {
  API_URL: location.protocol + '//' + location.host + '/api'
}



// WEBPACK FOOTER //
// ./src/config.js